import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useContent } from "@/lib/useContent";
import { usePageMeta } from "@/lib/seo";

export default function LegalPage() {
  const { slug } = useParams();
  const legal = useContent("legal");
  const page = (legal || []).find((p) => p.slug === slug);
  usePageMeta(page?.title, page ? `${page.title} — Makchester Tours & Travel, an international travel company registered in the UAE, Zimbabwe and South Africa.` : undefined);
  if (legal && legal.length > 0 && !page) return <Navigate to="/" replace />;
  if (!page) return null;
  return (
    <div className="bg-white">
      <section className="bg-[#0A2E4D] py-20">
        <div className="max-w-3xl mx-auto px-6">
          <span className="mk-gold-line mb-6 block" />
          <h1 className="font-serif-display text-3xl sm:text-4xl text-white" data-testid="legal-page-title">{page.title}</h1>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-6 py-16">
        {page.body.split("\n\n").map((p, i) => <p key={i} className="text-[#374151] leading-[1.9] mb-5 text-[15px]">{p}</p>)}
        <p className="text-xs text-[#9CA3AF] mt-8">Makchester Tours &amp; Travel — an international travel company registered in the United Arab Emirates, Zimbabwe and South Africa.</p>
      </article>
    </div>
  );
}
